import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Stack, Typography, Box} from 'views/components';
import {Author, EmojiBar, MarkdownViewer} from 'views/module';

import {HoverToolBox, Translate, translate} from 'views/module';

import displayResource from 'utils/miscellaneous/display_resource';

import moment from 'moment';

const CaregiverAnnouncement = (props) => {
  const [mouseOver, setMouseOver] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const {
    caregiverData,
    caregiverBackend,
    userRn,
  } = props;

  const latestAnnouncementMessage = caregiverData.latestAnnouncementMessage;

  const onEmojiSelected = (emoji) => {
    const prevMessage = latestAnnouncementMessage;
    const prevEmoji = prevMessage.emoji;
    // find if we previously selected this emoji, then remove, else add
    if (prevEmoji) {
      const prevEmojiUsers = prevEmoji[emoji];
      if (prevEmojiUsers) {
        const requesterIndex = prevEmojiUsers.findIndex((user) => user === userRn);
        if (requesterIndex > -1) {
          caregiverBackend.messages.removeEmoji(prevMessage.messageRn, emoji, userRn);
          return;
        }
      }
    }
    caregiverBackend.messages.addEmoji(prevMessage.messageRn, emoji, userRn);
  };

  if (!latestAnnouncementMessage) {
    return null;
  }

  const message = latestAnnouncementMessage?.body?.blob;
  const submittedBy = latestAnnouncementMessage.submittedBy;
  const author = displayResource(submittedBy);
  const emojis = latestAnnouncementMessage.emoji;
  const emojisWithRequesterData = latestAnnouncementMessage.emojisWithRequesterData;

  const timestampPrefixLabel = translate('caregiver.CaregiverDetail.Correspondance.Correspondance.AnnouncedOn');
  const formattedTimestamp = moment(latestAnnouncementMessage.createdAt).format(translate('timeFormat.VerboseDay'));
  const timestampLabel = `${timestampPrefixLabel} ${formattedTimestamp}`;

  return (
    <Stack
      onMouseOver={(e) => setMouseOver(true) & setAnchorEl(e.currentTarget)}
      onMouseLeave={(e) => setMouseOver(false)}
      sx={{
        mx: 1,
        px: {md: 2, xs: 1},
        py: 1,
        backgroundColor: 'background.main',
        border: '1px solid',
        borderColor: 'primary.main',
        borderRadius: '4px',
        boxSizing: 'border-box',
      }}
    >
      <Typography
        variant='subtitle1'
        sx={{fontWeight: 500, color: 'primary.main'}}
      >
        <Translate expression="caregiver.CaregiverDetail.Correspondance.Header.LastAnnouncement" />
      </Typography>
      <Author
        fullName={author}
        timestampLabel={timestampLabel}
        nameSx={{fontWeight: 500}}
      />
      <MarkdownViewer value={message} />
      {
        emojis && Object.values(emojis).length > 0 && (
          <Box
            sx={{my: 1}}
          >
            <EmojiBar
              emojis={emojis || {}}
              emojisWithRequesterData={emojisWithRequesterData || {}}
              requesterRn={userRn}
              onEmojiSelected={onEmojiSelected}
            />
          </Box>
        )
      }
      <HoverToolBox
        toolBar={mouseOver}
        anchorEl={anchorEl}
        copiedText={message}
        onEmojiSelected={onEmojiSelected}
        hideTool={{
          edit: true,
          delete: true,
        }}
      />
    </Stack>
  );
};
CaregiverAnnouncement.propTypes = {
  caregiverData: PropTypes.object.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
  userRn: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  userRn: state.user.userRn,
});

export default connect(mapStateToProps, dispatch)(React.memo(CaregiverAnnouncement));
